import React from 'react';
import { Carousel } from 'react-bootstrap';


const Slider = ({start}) => {
    console.log(start);
    return (
        <>
         <Carousel fade>
            {/* <Carousel.Item>
                <img 
                 className="d-block w-100"
                 src="https://i02.appmifile.com/173_operator_in/09/06/2021/fde866737ea0357305c2d1c852541460.gif"
                 alt="First slide"></img>
                <Carousel.Caption>
                <h3>First slide label</h3>
                <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                </Carousel.Caption>

            </Carousel.Item> */}

            {
                start.map((item,index)=>{
                    return(
                    <Carousel.Item>
                <img 
                 className="d-block w-100"
                 src={item}
                 alt="First slide">
                 </img>

                    </Carousel.Item>
                    )
                })
            }

        </Carousel>   
        
        </>
    )
}

export default Slider
